import { useFormikContext } from 'formik'

import { FormBody } from '../../../Form'
import { CustomizeRecipientAudienceFormFields } from '../../NewsboardPostForm'

import * as styles from './NewsboardPostProfileWidgetAudienceFormFields.module.css'

function NewsboardPostProfileWidgetAudienceFormFields({
  isStaffUserAcc,
  ticker,
  onCancel,
}) {
  const { isSubmitting } = useFormikContext()

  return (
    <FormBody
      actionsProps={{
        ButtonAdd: false,
        ButtonClear: false,
        Header: false,
        UploadComponent: false,
        cancelProps: { onClick: onCancel },
        isSubmitting,
        submitProps: { isLoading: isSubmitting, title: 'Modal.SaveBtnKey' },
      }}
    >
      <div className={styles.formFieldsWrapper}>
        <CustomizeRecipientAudienceFormFields
          isStaffUserAcc={isStaffUserAcc}
          ticker={ticker}
        />
      </div>
    </FormBody>
  )
}

export default NewsboardPostProfileWidgetAudienceFormFields
